import * as React from 'react'
import styled from 'styled-components'

import { useTranslation } from 'app/hooks/use-translation'
import Chevron from 'app/icons/Chevron'

interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}

const ViewAllLink: React.FC<IProps> = (props) => {
  const t = useTranslation()

  return (
    <Link {...props}>
      <span>{t('view_all')}</span>
      <ChevronRight />
    </Link>
  )
}

export default ViewAllLink

const Link = styled.a`
  display: flex !important;
  align-items: center;
`

const ChevronRight = styled(Chevron)`
  rotate: 180deg;
  margin-left: 8px;
`
